export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M19.707 7.7072 10 17.4142l-5.707-5.707 1.4142-1.4142L10 14.5858l8.2928-8.2928 1.4142 1.4142z" } }];
export const iconName = 'checkmark';
export const checkmark = { iconName, paths };
export default paths;
